import { useEffect, useState } from 'react'
import { Anchor, Button, Group, Paper, Text, ThemeIcon } from '@mantine/core'
import { dropHandlers, openFilePicker } from '../lib/fileInputBridge'

// #1078 フォームのファイル入力(職務経歴書/ポートフォリオ/一括作成の取込ファイルなど)。
// ブラウザ標準の <input type="file"> は見た目を揃えられないため hidden にし(ERB 側で描画)、
// ここではドロップゾーン(クリックでも選択可)と、選択中ファイル名/現在のファイルへのリンクを描く。
// 送信は Rails のフォームに任せる(lib/fileInputBridge.js 経由で hidden input に載せる)。
export default function FilePickerField({
  inputId,
  currentUrl,
  currentName,
  buttonLabel = 'ファイルを選択',
  emptyLabel = 'ここにファイルをドロップ、またはクリックして選択',
  hint,
}) {
  const [fileName, setFileName] = useState(null)
  const [dragging, setDragging] = useState(false)

  useEffect(() => {
    const input = document.getElementById(inputId)
    if (!input) return undefined
    const onChange = () => {
      const file = input.files && input.files[0]
      setFileName(file ? file.name : null)
    }
    input.addEventListener('change', onChange)
    return () => input.removeEventListener('change', onChange)
  }, [inputId])

  const open = () => openFilePicker(inputId)
  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      open()
    }
  }

  let title
  let sub
  if (fileName) {
    title = fileName
    sub = currentUrl ? '保存すると現在のファイルを置き換えます' : '保存時にアップロードされます'
  } else if (currentUrl) {
    title = (
      <Anchor href={currentUrl} target="_blank" rel="noopener" size="sm" fw={600} onClick={(e) => e.stopPropagation()}>
        {currentName || currentUrl}
      </Anchor>
    )
    sub = '差し替える場合はファイルをドロップ、またはクリックして選択'
  } else {
    title = emptyLabel
    sub = hint
  }

  return (
    <Paper
      withBorder
      radius="md"
      p="sm"
      role="button"
      tabIndex={0}
      onClick={open}
      onKeyDown={onKeyDown}
      {...dropHandlers(inputId, setDragging)}
      style={{
        cursor: 'pointer',
        borderStyle: 'dashed',
        borderColor: dragging ? 'var(--mantine-color-brand-5)' : 'var(--mantine-color-gray-4)',
        background: dragging ? 'var(--mantine-color-brand-0)' : 'var(--mantine-color-gray-0)',
        transition: 'background-color 100ms ease, border-color 100ms ease',
      }}
    >
      <Group gap="sm" wrap="nowrap">
        <ThemeIcon variant="light" color="brand" size={40} radius="md" style={{ flexShrink: 0 }}>
          <span className="material-icons" style={{ fontSize: 22 }} aria-hidden="true">{fileName || currentUrl ? 'description' : 'upload_file'}</span>
        </ThemeIcon>
        <div style={{ minWidth: 0, flex: 1 }}>
          <Text size="sm" fw={600} lineClamp={1} component="div">{title}</Text>
          {sub && <Text size="xs" c="dimmed" lineClamp={1}>{sub}</Text>}
        </div>
        <Button variant="default" size="xs" style={{ flexShrink: 0 }} tabIndex={-1}>
          {buttonLabel}
        </Button>
      </Group>
    </Paper>
  )
}
